<template>
  <div>
    <v-server-table @loaded="onLoaded" ref="table" :columns="columns" :url="url" :options="options" style="overflow: hidden;">
      <div v-if="props.row.raison_sociale" slot="raison_sociale" slot-scope="props">
        <span v-if="hasHabilitation(props.row)"><a class="fiche-siren" href="#" @click.prevent="fiche(props.row)">{{ props.row.raison_sociale.substring(0,35) }} (OAG : <span style="color: #ff0032">{{ props.row.oag }} </span>  OAP : <span style="color: #ffa434">{{ props.row.oap }} </span>)</a>
        <i v-if="props.row.raison_sociale.length > 35" class="fa fa-question-circle pull-right" v-b-tooltip.hover :title="props.row.raison_sociale"></i></span>
        <span v-else>{{ props.row.raison_sociale.substring(0,35) }} (OAG : <span style="color: #ff0032">{{ props.row.oag }} </span>  OAP : <span style="color: #ffa434">{{ props.row.oap }} </span>)</span>
      </div>
      <div v-if="props.row.siren" slot="siren" slot-scope="props">
        <span v-if="hasHabilitation(props.row)"><a class="fiche-siren" href="#" @click.prevent="fiche(props.row)">{{ props.row.siren }}</a></span>
        <span v-else>{{ props.row.siren }}</span>
      </div>
      <div v-if="props.row.num_contrat" slot="num_contrat" slot-scope="props">
        <span>{{ props.row.num_contrat.substring(0,31) }}
        <i v-if="props.row.num_contrat.length > 31" class="fa fa-question-circle pull-right" v-b-tooltip.hover :title="props.row.num_contrat"></i></span>
      </div>
    </v-server-table>
  </div>
</template>

<script>
  import {getUser} from '../../../utils/auth';
  export default {
    name: "SirensTable",
    props: ["tableEntry"],
    data() {
      let self = this;
      return {
        url: '',
        columns: ['siren', 'raison_sociale', 'nic_siege', 'code_postal', 'delegation_commercial', 'department', 'num_contrat', 'segment_gestion', 'effectif', 'produits'],
        options: {
          headings: {
            siren: 'SIREN',
            raison_sociale: 'Raison Sociale',
            nic_siege: 'NIC Souscripteur',
            code_postal: 'CP',
            delegation_commercial: 'Délégation commerciale',
            department: 'Dpt',
            num_contrat: 'N° Contrat',
            segment_gestion: 'Segment Gestion',
            effectif: 'Effectif',
            produits: 'Produits',
          },
          filterable: false,
          resizableColumns: true,
          perPage: 10,
          perPageValues: [10, 20, 30, 40],
          orderBy: {ascending: true},
          requestFunction: function (data) {
            self.url = '/espaceGestion/siren/recherche'
            data['siren'] = self.formatSiren(self.tableEntry.siren)
            data['num_contrat'] = self.tableEntry.num_contrat
            data['raison_sociale'] = self.tableEntry.raison_sociale
            data['departement'] = self.tableEntry.departement
            data['delegationCommercialeId'] = self.tableEntry.delegationCommercialeId
            data['noSearch'] = self.$parent.noSearch
            self.$store.commit("IS_LOADING", true);
            return axios.get(self.url, {
              params: data
            })
              .then(function (response) {
                self.$store.commit('IS_LOADING', false)
                return response;
              })
              .catch(function (e) {
                self.$store.commit("IS_LOADING", false);
                self.$swal({
                  position: "top",
                  type: "error",
                  title: "Attention !!",
                  text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
                  showConfirmButton: false,
                  timer: 5000
                });
              }.bind(this));
          },
        }
      };
    },
    methods: {
      onLoaded() {
        this.$store.commit("IS_LOADING", false);
      },
      formatSiren(value) {
        let result = value;
        result = result.toString();
        result = result.replace(/ /g, '');
        result = result.replace(/\./g, '');
        result = result.replace(/-/g, '');
        result = result.replace(/_/g, '');
        return result;
      },
      fiche(data) {
        let siren = data.siren
        
        
        if (this.hasHabilitation(data)) {
          this.$router.push({
            path: "/espace-gestion/sirens/fiche/" + siren, query: {
              si: this.tableEntry.siren,
              nc: this.tableEntry.num_contrat,
              rs: this.tableEntry.raison_sociale,
              dpt: this.tableEntry.department,
              dci: this.tableEntry.delegationCommercialeId,
              oag: data.oag,
              oap: data.oap
            }
          })
        } else {
          this.$swal({
            position: "top",
            type: "warning",
            title: "Attention !",
            text: 'Vous n\'avez pas les habilitations pour consulter cette fiche SIREN',
            showConfirmButton: false,
            timer: 3000
          })
        }
      },
      hasHabilitation(entity) {
        let user = getUser();
        let userOags = user.profil_active[0].oags.map(oag => oag.code);
        let userOaps = user.profil_active[0].oaps.map(oap => oap.code);

        return userOags.indexOf(entity.oag) > -1 && userOaps.indexOf(entity.oap) > -1
      },
    }
  }
</script>

<style scoped>
  .VueTables__search-field input {
    width: 240px !important;
  }
</style>
